import { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { FaMagnifyingGlass } from 'react-icons/fa6';
import { parseISO, isBefore, startOfMonth, endOfMonth, format } from 'date-fns';
import api from '../api/ChoiceReq';
import DateInput from "../components/InputDate";
import TimeInput from "../components/InputTime";
import SelectThoroughfare from "../components/SelectThroughfare";
import SelectPlace from "../components/SelectPlace";
import BackButton from "../components/BackButton";
import SelectTypeLines from "../components/SelectTypeLines";
import { toast } from "sonner";


const Choice = () => {
    
    const [flowMeters, setFlowMeters] = useState([]);

    const [selectedPlace, setSelectedPlace] = useState('');
    const [places, setPlaces] = useState([]);
    const [selectedThoroughfare, setSelectedThoroughfare] = useState('');
    const [thoroughfares, setThoroughfares] = useState([]);
    const [selectedTypeLine, setSelectedTypeLine] = useState('');
    const [typeLines, setTypeLines] = useState([]);

    // CURRENT MONTH 
    const firstDay = startOfMonth(new Date());
    const formattedFirstDay = format(firstDay, 'yyyy-MM-dd');
    const lastDay = endOfMonth(new Date());
    const formattedLastDay = format(lastDay, 'yyyy-MM-dd');
    //
    const [selectedFromDate, setSelectedFromDate] = useState(formattedFirstDay);
    const [selectedFromTime, setSelectedFromTime] = useState('00:00:00');
    const [selectedToDate, setSelectedToDate] = useState(formattedLastDay);
    const [selectedToTime, setSelectedToTime] = useState('23:59:59');

    const handleChangeFromDate = (event) => {
        setSelectedFromDate(event.target.value)
    };
    const handleChangeFromTime = (event) => {
        setSelectedFromTime(event.target.value)
    };
    const handleChangeToDate = (event) => {
        setSelectedToDate(event.target.value)
    };
    const handleChangeToTime = (event) => {
        setSelectedToTime(event.target.value)
    };

    const navigate = useNavigate();

    useEffect(() => {
        const fetchFlowMeters = async () => {
            try {
                const response = await api.get('all', {withCredentials: true});
                if (response.data.success) {
                    setFlowMeters(response.data.payload);
                } else {
                    console.error('Error:', response.data.message)
                }
            } catch (err) {
                console.log(err.response);
            }
        };

        fetchFlowMeters();
    }, []);

    useEffect(() => {
        const handlePlaces = () => {
            const newplaces = [...new Set(flowMeters.map(item => item.location_id.place))] 
            return newplaces.map((name, index) => ({id: index+1, name: name}));
            
        }
        if (flowMeters.length > 0) {
            setPlaces(handlePlaces());
        }
    }, [flowMeters])

    useEffect(() => {
        const filterPlaces = () => {
            const newthoroughfare = flowMeters.filter(flowmeter => flowmeter.location_id.place === selectedPlace).map((fl, index) => ({id: index+1, name: fl.location_id.thoroughfare}))
            return newthoroughfare.reduce((acc, current) => {
                if (!acc.some(item => item.name === current.name)) {
                    acc.push(current);
                }
                return acc
            }, [])
        }
        if (flowMeters.length > 0) {
            setThoroughfares(filterPlaces())
        }
    }, [selectedPlace])

    useEffect(() => {
        const filterPlacesAndThoroughfares = () => {
            const newTypeLines = flowMeters
                                    .filter(flowmeter => flowmeter.location_id.place === selectedPlace && flowmeter.location_id.thoroughfare === selectedThoroughfare)
                                    .map((fl, index) => ({id: index+1, name: fl.location_id.type_line}))
            
            return newTypeLines.reduce((acc, current) => {
                if (!acc.some(item => item.name === current.name)) {
                    acc.push(current);
                }
                return acc
            }, [])
        }
        if (flowMeters.length > 0) {
            setTypeLines(filterPlacesAndThoroughfares())
        }
    }, [selectedThoroughfare])

    const handleDashboardButton = () => {
        const areDatesAndTimesSet = selectedFromDate &&
                                    selectedFromTime &&
                                    selectedToDate &&
                                    selectedToTime

        if (!areDatesAndTimesSet) {
            toast.error('Error! Insert all dates and times!');
            return
        }

        const dateTimeFromBeforeParsing = `${selectedFromDate}T${selectedFromTime}`
        const dateTimeToBeforeParsing = `${selectedToDate}T${selectedToTime}`

        const dateTimeFromParsed = parseISO(dateTimeFromBeforeParsing)
        const dateTimeToParsed = parseISO(dateTimeToBeforeParsing)

        if (!isBefore(dateTimeFromParsed, dateTimeToParsed)) {
            toast.error('Error! First datetime is not earlier!')
            return
        }

        const filteredFlowMeterId = flowMeters
                                        .filter(
                                            flowmeter => flowmeter.location_id.place === selectedPlace &&
                                            flowmeter.location_id.thoroughfare === selectedThoroughfare && 
                                            flowmeter.location_id.type_line === selectedTypeLine)
                                        .map((flowmeter) => (flowmeter.id))[0]
        navigate(`/dashboard/dashboard/${filteredFlowMeterId}/${dateTimeFromBeforeParsing}/${dateTimeToBeforeParsing}`)
    }

    return (
        <div className="choice-container">
            <h2>Choice</h2>
            <br />
            <div className="choice-card">
                <h4>Flow Meter</h4>
                <div className="choice-input-group">
                    <label
                        htmlFor=''
                        className='bold-label'
                    >
                        Place:
                    </label>
                    <SelectPlace
                        places={places}
                        selectedPlace={selectedPlace}
                        setSelectedPlace={setSelectedPlace}
                    />
                </div>
                <div className="choice-input-group">
                    <label
                        htmlFor=''
                        className='bold-label'
                    >
                        Section:
                    </label>
                    <SelectThoroughfare
                        thoroughfares={thoroughfares}
                        selectedThoroughfare={selectedThoroughfare}
                        setSelectedThoroughfare={setSelectedThoroughfare}
                    />
                </div>
                <div className="choice-input-group">
                    <label
                        htmlFor=''
                        className='bold-label'
                    >
                        Type line:
                    </label>
                    <SelectTypeLines
                        LocationTypeLines={typeLines}
                        selectedlocationTypeLine={selectedTypeLine}
                        setSelectedLocationTypeLine={setSelectedTypeLine}
                    />
                </div>
                <h4>Flow Measurement</h4>
                <div className="choice-input-group">
                    <label
                        htmlFor=''
                        className='bold-label'
                    >
                        FROM:
                    </label>
                    <div>
                        <DateInput 
                            selectedDate={selectedFromDate}
                            handleSelectedDate={handleChangeFromDate}
                        />
                        <TimeInput 
                            selectedTime={selectedFromTime}
                            handleSelectedTime={handleChangeFromTime}
                        />    
                    </div>
                    
                </div>
                <div className="choice-input-group">
                    <label
                        htmlFor=''
                        className='bold-label'
                    >
                        TO:
                    </label>
                    <div className="choice-date-time-group">
                        <DateInput 
                            selectedDate={selectedToDate}
                            handleSelectedDate={handleChangeToDate}
                        />
                        <TimeInput 
                            selectedTime={selectedToTime}
                            handleSelectedTime={handleChangeToTime}
                        />
                    </div>
                </div>
                <button className='menu-button' onClick={handleDashboardButton}>
                    Dashboard <FaMagnifyingGlass />
                </button>
            </div>
            <BackButton navigateTo='/menu'/>
        </div>
    );
};

export default Choice;